import {BaseModel} from '../base/BaseModel';

/**
 * @class DistributorModel
 * @extends BaseModel
 */
export class DistributorModel extends BaseModel {

    get idAttribute () {

        return 'uuid';
    }

    initialize () {

        this.microservice = 'users';
        this.resource = 'distributors';
    }

    defaults () {

        return {
            companyName: '',
            gigya: null // hash of GIGYA stored attributes
        };
    }
}



// WEBPACK FOOTER //
// ./shared/model/users/DistributorModel.js